export default __webpack_public_path__ + "static/media/cyber_structure_glow_darker_cyan.69d1d076.png";